import { ReactNode } from "react";
import ReactModal from "react-modal";

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  header?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
}

const BaseModal = ({
  isOpen,
  onRequestClose,
  header,
  children,
  footer,
}: Props) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="react-modal approveai-container"
      overlayClassName="react-modal-overlay"
    >
      {header && <div className="react-modal__header">{header}</div>}
      {children && (
        <div className="react-modal__body update-modal__body">{children}</div>
      )}
      {footer && <div className="react-modal__footer">{footer}</div>}
    </ReactModal>
  );
};

export default BaseModal;
